import { SHOP_ID_LSK } from 'app.constants'

// an interface declaration to handle the window.shopId type:
declare global {
    interface Window {
        shopId: string | undefined,
        shopName: string | undefined
    }
}

//getShopId:
export const getShopId = () => {
    let id = ''
    try{
        id = localStorage.getItem(SHOP_ID_LSK) ?? ''
    }catch(e){
        id = window.shopId ?? ''
    }
    return id
}

export const getShopName = () => {
    return window.shopName ?? ''
}

//updateShopId:
export const updateShopId = (id: string | null) => {
    try{
        if(id){
            localStorage.setItem(SHOP_ID_LSK, id)
        }else{
            localStorage.removeItem(SHOP_ID_LSK)
        }
    }catch(e){
        window.shopId = id ?? undefined
    }
}

export const updateShopName = (name: string | null) => {
    return window.shopName = name ?? undefined
}
